<div class="table-header">
  @if (!disableTable) {
    <div class="btn-group">
      @if (applyAllAllowed()) {
        <button class="secondary_button" (click)="cancelSelection()">Cancel</button>
        <button class="primary_button" (click)="applyEnteredValueForSelectedRows()">Apply All</button>
      }
    </div>
  }
</div>

<div class="table_with_grid">
  <div class="table_container">
      <table>
        <thead>
        <tr #headerRow>

          <th *ngIf="showAccordion" class="expand-cell"></th>

          <th class="cb_th" *ngIf="allowSelection">
            <input type="checkbox"
                   [checked]="isAllRecordsOfCurrentPageSelected()"
                   (change)="toggleAllRecordsOfCurrentPageSelections($event.target.checked)"
            />
          </th>
          @if (!allowSelection) {
            <th class="sl_th">
              <div class="sl_th_text">SL No.</div>
            </th>
          }
          @for (header of tableMeta.columns; track $index; let i = $index) {
            <th [ngClass]="{
            'pinned': i === 0            }">
              <div class="header_content_editable_table" [ngStyle]="header?.thStyleConfig">
                @if (header.editable && showInputFieldsOnTh) {
                  <div class="header_checkbox">
                    <input type="checkbox" (change)="selectColumns(header.fieldName)"
                           [checked]="isSelectedColumn(header.fieldName)">
                  </div>
                }
                <div class="header_text_with_input_box">
                  <div class="table_header_text">{{ header.displayName }}</div>
                  @if (header.editable && showInputFieldsOnTh) {
                    <app-editable-table-dynamic-input
                      #headerInput
                      [header]="header"
                      (updateValue)="updateColumnValue(header, $event)"
                      [disabled]="disableTable"
                    >
                    </app-editable-table-dynamic-input>
                  }
                </div>

              </div>
            </th>
          }
          <th class="sticky-actions actions_th" *ngIf="hasVisibleActions() && tableData?.length > 0"
            [ngStyle]="tableMeta?.actions?.[0]?.thStyleConfig || {}"></th>
        </tr>
        </thead>
        <tbody>
          @if (tableData?.length === 0) {
            <tr>
              <td [attr.colspan]="totalColspan">
                <app-no-data [msg]="noDataFoundErrorMsg" [path]="noDataFoundIcon"></app-no-data>
              </td>
            </tr>
          } @else {

            @for (row of tableData; track $index; let rowIndex = $index) {
              <tr class="data-row" [class.expanded]="showAccordion && expandedRowIndex === rowIndex" (click)="showAccordion && toggleRow(rowIndex)" (keydown.enter)="showAccordion && toggleRow(rowIndex)"
                [ngClass]="{
                'selected-row': isSelected(row),
              }"
              >

              <td *ngIf="showAccordion" class="expand-cell">
                <div class="icon-wrapper">
                  <app-svg-icon
                    [path]="expandedRowIndex === rowIndex ? 'assets/icons/chevron_up.svg' : 'assets/icons/chevron_down.svg'"
                    class="icon"
                  ></app-svg-icon>
                </div>
              </td>

                <td class="cb_td row-select-cb" *ngIf="allowSelection">
                  <input
                    type="checkbox"
                    [id]="'record_sl_no_' + row?.uniqueId"
                    [checked]="isSelected(row)"
                    (change)="toggleSelection(row)"
                  />
                </td>
                <td class="sl_td" *ngIf="!allowSelection">
                  {{ rowIndex + 1 }}
                </td>
                @for (column of tableMeta.columns; track $index; let colIndex = $index) {
                  <td [ngClass]="{'pinned': colIndex === 0}">
                    @if (column.editable || (column?.conditionalEditable ?? false)) {
                      @if (column?.conditionalEditable ?? false) {
                        <div class="row_checkbox">
                          <input type="checkbox" (change)="toggleDependency(column, row)"
                                [checked]="isCellEditable(column, row)">
                        </div>
                      }
                      <app-editable-table-dynamic-input
                        #tableDataInput
                        [column]="column"
                        [record]="row"
                        [value]="getColumnValue(row, column, false)"
                        (updateValue)="updateValue($event, rowIndex, column)"
                        [disabled]="isCellDisabled(header, row)"
                      >
                      </app-editable-table-dynamic-input>
                    } @else {
                      <app-tos-table-td
                          [value]="getColumnValue(row, column, true)"
                          [rowData]="row"
                          [column]="column"
                      ></app-tos-table-td>
                    }
                  </td>
                }
                <td class="sticky-actions actions_td" *ngIf="hasVisibleActions()">
                  <div class="action_buttons_wrapper">
                    @for (column of tableMeta.actions; track $index) {
                      @if (!(disableTable && column?.styleConfig?.actionConfig?.writeOpertion)) {
                        <app-tos-table-td
                          [value]="getColumnValue(row, column, true)"
                          [rowData]="row"
                          [column]="column"
                          (inlineAction)="handleInlineAction($event, rowIndex)"
                        ></app-tos-table-td>
                      }
                    }
                  </div>
                </td>
              </tr>

              <tr class="expanded-content" [class.expanded]="expandedRowIndex === rowIndex">
                <td [attr.colspan]="totalColspan">
                  <ng-template #accordionContent></ng-template>
                </td>
              </tr>
            }
          }
      </tbody>
    </table>
  </div>
</div>
